import { BaseService } from "./base.service";
export class ProgramCriterionCategoriesService extends BaseService {
  constructor() {
    super("program-criterion-categories");
  }
}
